import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import { IconArrowLeft } from '@xingternal/icons';

import styles from './BackButton.css';

export const BackButton = ({
  url,
  className = '',
}: {
  url: string;
  className?: string;
}) => {
  const newClass = classnames(className, styles.backButtonLink);
  const history = useHistory();

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, []);

  return (
    <Link to={url} className={newClass}>
      <IconArrowLeft className={className} width={36} height={36} />
    </Link>
  );
};
